export const toggleSelected = (current: string[], toggle: string): string[] =>
  current.includes(toggle)
    ? current.filter((item) => item !== toggle)
    : [...current, toggle];

export default toggleSelected;
